module.exports = __webpack_public_path__ + "media/images/users/user-5-81ded97a5d84cbfd38c1790c32ab4c87.jpg";